import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ImageResizeService {

  constructor() { }

  resize(image, maxWidth: number = 1920, maxHeigth: number = 1920): Promise<string> {
    return new Promise((resolve, reject) => {
      try {
        let img = new Image;
        let canvas = document.createElement("canvas");
    
        img.onload = () => {
          let size = this.newSize(img, maxWidth, maxHeigth);
          let ctx = canvas.getContext("2d");
          canvas.width = size.width;
          canvas.height = size.height;
          ctx.drawImage(img, 0, 0, size.width, size.height);
          const dataUrl = canvas.toDataURL();
          resolve(dataUrl);
        }
        img.src = image;
      } catch (error) {
        reject(error);
      }
    });
  }

  private newSize(img, maxWidth, maxHeight): { width: number, height: number } {
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);

    const MAX_WIDTH = maxWidth;
    const MAX_HEIGHT = maxHeight;
    let width = img.width;
    let height = img.height;

    if (width > height) {
      if (width > MAX_WIDTH) {
        height *= MAX_WIDTH / width;
        width = MAX_WIDTH;
      }
    } else {
      if (height > MAX_HEIGHT) {
        width *= MAX_HEIGHT / height;
        height = MAX_HEIGHT;
      }
    }
    return { width: width, height: height };
  }

}
